import * as React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FormManager, PageTitle, Update, useCacheRecord } from 'gossamer-front-end';
import { Location } from 'cb-model';
import { getListRowLink } from 'gossamer-unified';

export const LocationUpdate = (): React.JSX.Element => {
  const params = useParams();
  const navigate = useNavigate();
  const record = useCacheRecord(Location, params.key);
  const handleExit = () => navigate(getListRowLink(Location.listRowLink, params.key));

  return (
    <>
      <PageTitle verb="Update" entity={Location} keyValue={params.key} />
      <FormManager
        compoundUrl="/main/~/location-update"
        handleCancel={handleExit}
        handleSuccess={handleExit}
        initialization={{
          main: { type: 'update-single', entity: Location, record },
        }}
      >
        <Update valuesKey="main" entity={Location} />
      </FormManager>
    </>
  );
};
